import {Modal} from 'react-bootstrap'
import ModalHeader from 'components/Modal/ModalHeader'
import {FieldArray, getFormValues} from 'redux-form'
import ModifierOptionsFieldArray from './ModifierOptionsFieldArray'
import {connect} from 'react-redux'
import {onCancelManageModifierOptions, onConfirmManageModifierOptions} from 'actions/library/modifier'
import styles from './ModifierOptionsModal.css'

class ModifierOptionsModal extends React.Component {
  render () {
    const {showModifierOptionsModal} = this.props
    return (<Modal show={showModifierOptionsModal} onHide={this._onCancel} dialogClassName={`modal-dialog ${styles.dialog}`}>
      <ModalHeader title={'Add Option'} />
      <Modal.Body bsClass={`modal-body ${styles.body}`}>
        <FieldArray
          name='options'
          component={ModifierOptionsFieldArray}
        />
      </Modal.Body>
      <Modal.Footer>
        <span className='pull-left'>
          <button className='btn btn-default' onClick={this._onCancel}>Cancel</button>
        </span>
        <span className='pull-right'>
          <button className='btn btn-primary' onClick={this._onSave}>Save</button>
        </span>
      </Modal.Footer>
    </Modal>)
  }

  _onCancel = () => {
    const {dispatch, previousModifierForm} = this.props
    dispatch(onCancelManageModifierOptions(previousModifierForm))
  }

  _onSave = () => {
    const {dispatch, modifier: {options}} = this.props
    dispatch(onConfirmManageModifierOptions(options))
  }
}

function mapStateToProps (state) {
  const {showModifierOptionsModal, previousModifierForm} = state.library.modifier
  return {
    showModifierOptionsModal,
    previousModifierForm,
    modifier: getFormValues('modifier')(state)
  }
}

function mapDispatchToProps (dispatch) {
  return {dispatch}
}

export default connect(mapStateToProps, mapDispatchToProps)(ModifierOptionsModal)



// WEBPACK FOOTER //
// ./app/pages/Library/Modifier/Detail/ModifierForm/ModifierOptionsModal/ModifierOptionsModal.js